module.exports = __webpack_public_path__ + "img/INS.9f1b5765.svg";